import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import Utils from 'src/app/helpers/utils';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent implements OnInit {
  @Input() claimDto!: ClaimDto;
  badgeBackgroundClass = '';
  statusText = '';

  constructor(private utils: Utils) {}

  ngOnInit(): void {
    this.badgeBackgroundClass = `bg-${this.utils.renderStatusClass(this.claimDto.status)}`

    if (this.statusText === '') {
      this.statusText = this.claimDto!.status;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.claimDto) {
      this.badgeBackgroundClass = `bg-${this.utils.renderStatusClass(this.claimDto.status)}`
      this.statusText = this.claimDto!.status;
    }
  }

}
